
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Task } from '@/types/task';
import { TaskCard } from './TaskCard';
import { Card } from '@/components/ui/card';

interface KanbanTaskCardProps {
  task: Task;
  onClick: () => void;
  isOverlay?: boolean;
}

export const KanbanTaskCard = ({ task, onClick, isOverlay }: KanbanTaskCardProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: task.id, data: { type: 'Task', task } });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  if (isOverlay) {
    return <TaskCard task={task} />;
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={isDragging ? 'opacity-50' : ''}
    >
      <TaskCard task={task} onClick={onClick} />
    </div>
  );
};
